import { render, staticRenderFns } from "./DelSysMessage.vue?vue&type=template&id=09bb0a76&scoped=true&"
import script from "./DelSysMessage.vue?vue&type=script&lang=js&"
export * from "./DelSysMessage.vue?vue&type=script&lang=js&"
import style0 from "./DelSysMessage.vue?vue&type=style&index=0&id=09bb0a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bb0a76",
  null
  
)

export default component.exports